import { render, staticRenderFns } from "./FansRecord.vue?vue&type=template&id=385198ac&scoped=true"
import script from "./FansRecord.vue?vue&type=script&lang=js"
export * from "./FansRecord.vue?vue&type=script&lang=js"
import style0 from "./FansRecord.vue?vue&type=style&index=0&id=385198ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385198ac",
  null
  
)

export default component.exports